export default __webpack_public_path__ + "static/media/bajookieland-style-guide.7b77a904.jpg";